import {
  PartnerOfferCategory,
  Query,
  SortBy,
} from '@varo/graphql-schema-types';
import FetchPartnerOffersCategories from 'services/graphql/queries/FetchPartnerOffersCategories';
import { AnyVariables, CombinedError, useQuery } from 'urql';

interface PartnerOfferCategoriesData {
  loading: boolean;
  error?: CombinedError;
  categoriesResponse?: PartnerOfferCategory[];
}

const usePartnerOffersCategories = (): PartnerOfferCategoriesData => {
  const [{ data: perksAllCategoriesData, fetching: loading, error }] = useQuery<
    Query,
    AnyVariables
  >({
    query: FetchPartnerOffersCategories,
    requestPolicy: 'cache-and-network',
    variables: {
      categorySortBy: SortBy.Name,
    },
  });

  const categoriesResponse =
    perksAllCategoriesData?.myPartnerOffers?.categories ?? [];

  return {
    loading,
    error,
    categoriesResponse,
  };
};

export default usePartnerOffersCategories;
